module.exports = __webpack_public_path__ + "img/new_index_banner1.9556b63d.jpg";